import { Subject, Observable } from "rxjs";
import { environment } from "../environments/environment";
import { ServerConfigService } from "./share/service/server-config.service";
import { BackStageTemplateService } from "./share/service/back-stage-template.service";
import { LoggerService } from "./share/service/logger.service";
import { BackStagePayload } from "./web-generator/template-generator/entity/back-stage-payload";
import { take } from "rxjs/operators";

/** 檢查首頁編輯合法性後進行基本設定 */
export function backstageEditModeInitFn(serverConfigService: ServerConfigService, isBrowser: boolean, backStageTemplateService: BackStageTemplateService, locationInitialized: Promise<any>, loggerService: LoggerService): Observable<any> {
  return new Observable(obs => {
    locationInitialized.then(() => {
      if (!isBrowser) {
        // loggerService.info(`locationInitialized`);
      }
      let backStageSubj: Subject<BackStagePayload>;
      if (isBrowser) {
        const url = serverConfigService.url;
        if (serverConfigService.isEditModeUrl) { // 'aHR0cCUzQSUyRiUyRmxvY2FsaG9zdCUzQTQzMDA='
          const queryParamSatrtIndex = url.indexOf('?');
          const url2 = url.slice(0, queryParamSatrtIndex);
          let stageUrl: string;
          let match: any;
          try {
            stageUrl = decodeURIComponent(atob(decodeURIComponent(serverConfigService.queryParams['stage'])));
            match = environment.allowBackStageDomain.find(domain => domain === stageUrl);
          } catch (e) {
            loggerService.error('', e);
          }
          const opener = window.opener;
          if (environment.production) {
            if (!opener || opener === window || !match || !stageUrl)  {
              if (!opener) {
                loggerService.error('no opener');
              } else if (opener === window) {
                loggerService.error('open self');
              } else if (!match) {
                loggerService.error('allowBackStageDomain not match');
              }
              alert('請從後台進入!');
              window.location.href = url2;
            }
          }
  
          const urlSegs = url2.replace(/https?:\/\//g, '').split('/');
          const isIndexPage = urlSegs.length === 2;
          const isSubjectDetailPage = urlSegs.length === 4;
          window.opener.postMessage('appInit', stageUrl);
          backStageTemplateService.setStageUrl(stageUrl);
          backStageSubj = backStageTemplateService.listenOnWindowMessage(isIndexPage, isSubjectDetailPage);
        }
      }
  
      if (backStageSubj) {
        backStageSubj.pipe(take(1)).subscribe(_ => {
          obs.next(_)
          obs.complete();
        });
      } else  {
        obs.next(null)
        obs.complete();
      }
    });
  });
}